var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.isDisplayed
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c('div', {
    staticClass: "mx-5 xl:mx-15 2xl:mx-20 my-8 w-auto h-auto"
  }, [_vm.jobNotFound === false ? _c('h3', {
    staticClass: "mb-6 text-3xl font-normal"
  }, [_vm._v("\n      " + _vm._s(_vm.libellePage) + " : Ajouter\n      " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'une formation' : 'un poste') + "\n    ")]) : _vm.jobNotFound === true ? _c('h3', {
    staticClass: "mb-6 text-3xl font-normal"
  }, [_vm._v("\n      " + _vm._s(_vm.libellePage)), _c('span', {}, [_vm._v("\n        :\n        " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'Référentiel de formation inexistant' : 'Fiche de poste inexistante'))])]) : _vm._e(), _vm._v(" "), _vm.jobNotFound === false && _vm.descs.length > 0 ? _c('h6', {
    staticClass: "text-indigo-600 mb-5"
  }, [_vm._v("\n      Sélectionnez depuis\n      " + _vm._s(_vm.$isGuest() ? 'la bibliothèque personnelles de ' + _vm.infosPass.name : 'votre bibliothèque personnelle') + ",\n      " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'le référentiel de formation' : 'la fiche de poste') + "\n      dont vous avez besoin pour débuter une évaluation.\n    ")]) : _vm.jobNotFound === true ? _c('h6', {
    staticClass: "text-pink-600 mb-5 font-normal italic text-base w-3/4 m-auto"
  }, [_vm._v("\n      Suite à une suppression,\n      " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'le référentiel de formation' : 'la fiche de poste') + "\n      \"" + _vm._s(_vm.deletedDesc.name) + "\" ne fait plus partie de votre bibliothèque\n      personnelle. "), _c('br'), _vm.descs.length > 0 ? _c('span', [_vm._v("Veuillez ajouter\n        " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'un nouveau référentiel de formation' : 'une nouvelle fiche de poste') + "\n        à intégrer\n        " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'à la formation' : 'au poste') + "\n        " + _vm._s(_vm.job))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.descs.length > 0,
      expression: "descs.length > 0"
    }]
  }, [_c('div', {
    staticClass: "relative flex flex-col justify-center items-center text-base font-normal text-gray-900"
  }, [_c('div', {
    staticClass: "w-full lg:w-1/3"
  }, [_c('input-drop-down', {
    ref: "inputDropDownDescs",
    attrs: {
      "options": _vm.descs,
      "disabled": false,
      "name": _vm.typeStructure == _vm.constants.TYPE_OF ? 'Référentiel de formation' : 'Fiche de poste',
      "max-item": 10,
      "placeholder": 'Saisir le nom ' + (_vm.typeStructure == _vm.constants.TYPE_OF ? 'du référentiel de formation' : 'de la fiche de poste'),
      "libelle": _vm.typeStructure == _vm.constants.TYPE_OF ? 'Référentiel de formation' : 'Fiche de poste'
    },
    on: {
      "selected": _vm.selectDesc,
      "noResult": function ($event) {
        _vm.noSearchResult = true;
      },
      "foundResult": function ($event) {
        _vm.noSearchResult = false;
      }
    }
  })], 1), _vm._v(" "), _vm.noSearchResult ? _c('p', {
    staticClass: "cursor-default pt-3 pb-1 text-sm text-center text-pink-600 italic"
  }, [_vm._v("\n          Si vous ne trouvez pas de\n          " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'référentiel de formation correspondant' : 'fiche de poste correspondante') + "\n          à votre recherche, vous avez la possibilité de faire une recherche\n          dans la\n          "), _c('span', [_c('router-link', {
    staticClass: "text-indigo-600 underline",
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'common'
        }
      }
    }
  }, [_vm._v("\n              bibliothèque commune\n            ")])], 1), _vm._v("\n          pour voir si\n          " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'il' : 'elle') + " existe, ou\n          de " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'le' : 'la') + "\n          "), _c('span', [_c('router-link', {
    staticClass: "text-indigo-600 underline",
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'newDesc'
        }
      }
    }
  }, [_vm._v("\n              créer\n            ")])], 1), _vm._v(".\n        ")]) : _vm._e()]), _vm._v(" "), true ? _c('div', [_c('h5', {
    staticClass: "my-5"
  }, [_vm._v("OU")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col justify-center w-full mb-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-4 w-full text-base font-normal text-gray-900 mb-2 gap-x-4"
  }, [_c('input-drop-down', {
    ref: "inputDropDownType",
    staticClass: "md:col-span-1",
    attrs: {
      "options": _vm.types,
      "disabled": false,
      "name": 'Type de ' + (_vm.typeStructure == _vm.constants.TYPE_OF ? 'référentiel' : 'fiche'),
      "max-item": 2,
      "placeholder": "",
      "libelle": 'Type de ' + (_vm.typeStructure == _vm.constants.TYPE_OF ? 'référentiel' : 'fiche'),
      "has-chevron": true
    },
    on: {
      "selected": _vm.selectTypeDesc
    }
  }), _vm._v(" "), _c('input-drop-down', {
    ref: "inputDropDownSector",
    staticClass: "md:col-span-1",
    attrs: {
      "options": _vm.sectors,
      "disabled": false,
      "name": "Secteurs d'activité",
      "max-item": 10,
      "placeholder": "",
      "libelle": "Secteur d'activité",
      "has-chevron": true
    },
    on: {
      "selected": _vm.selectSector
    }
  }), _vm._v(" "), _c('input-drop-down', {
    ref: "inputDropDownFamily",
    staticClass: "md:col-span-1",
    attrs: {
      "options": _vm.families,
      "disabled": false,
      "name": "Famille professionnelle",
      "max-item": 10,
      "placeholder": "",
      "libelle": "Famille professionnelle",
      "has-chevron": true
    },
    on: {
      "selected": _vm.selectFamily
    }
  }), _vm._v(" "), _c('input-drop-down', {
    ref: "inputDropDownFilteredDescs",
    staticClass: "md:col-span-1",
    attrs: {
      "options": _vm.filteredDescs,
      "disabled": false,
      "name": _vm.typeStructure == _vm.constants.TYPE_OF ? 'Référentiels filtrés' : 'Fiches de poste filtrées',
      "max-item": 10,
      "placeholder": "",
      "libelle": _vm.typeStructure == _vm.constants.TYPE_OF ? 'Référentiel de formation' : 'Fiche de poste',
      "has-chevron": true
    },
    on: {
      "selected": _vm.advancedSearchSelectDesc,
      "noResult": function ($event) {
        _vm.noAdvancedSearchResult = true;
      },
      "foundResult": function ($event) {
        _vm.noAdvancedSearchResult = false;
      }
    }
  })], 1), _vm._v(" "), _vm.noAdvancedSearchResult ? _c('p', {
    staticClass: "cursor-default pt-3 pb-1 text-sm text-center text-pink-600 italic"
  }, [_vm._v("\n            Il n'y a pas de fiche de poste correspondante à votre recherche,\n            vous avez la possibilité de faire une recherche dans la\n            "), _c('span', [_c('router-link', {
    staticClass: "text-indigo-600 underline",
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'common'
        }
      }
    }
  }, [_vm._v("\n                bibliothèque commune\n              ")])], 1), _vm._v("\n            pour voir si elle existe, ou de la\n            "), _c('span', [_c('router-link', {
    staticClass: "text-indigo-600 underline",
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'newDesc'
        }
      }
    }
  }, [_vm._v("\n                créer\n              ")])], 1), _vm._v(".\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-max-content w-max mx-auto mt-10"
  }, [_c('action-button', {
    attrs: {
      "is-disabled": !_vm.selectedDesc.id,
      "right": true,
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Continuer",
      "uppercase": true,
      "icon": "arrow-right_1",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        _vm.selectedDesc.id ? _vm.$emit('selectJobDesc', _vm.selectedDesc) : null;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.descs.length === 0,
      expression: "descs.length === 0"
    }]
  }, [_c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_c('div', [_vm._v("\n          Il n'y a\n          " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'aucun référentiel de formation' : 'aucune fiche de poste') + "\n          dans " + _vm._s(_vm.$isGuest ? 'la' : 'votre') + " bibliothèque personnelle" + _vm._s(_vm.$isGuest ? ' de ' + _vm.infosPass.name : '') + ".\n        ")]), _vm._v(" "), !_vm.$isGuest() ? _c('div', [_vm._v("\n          Vous avez la possibilité d'ajouter\n          " + _vm._s(_vm.typeStructure == _vm.constants.TYPE_OF ? 'un référentiel de formation' : 'une fiche de poste') + "\n          depuis la bibliothèque commune\n          " + _vm._s(_vm.$freeParticulier() ? '' : ", ou d'en créer" + (_vm.typeStructure === _vm.constants.TYPE_OF ? 'un' : 'une')) + ".\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "no_result"
    }
  })], 1), _vm._v(" "), !_vm.$isGuest() ? _c('div', {
    staticClass: "flex space-x-5 justify-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'common'
        }
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Ajouter depuis la bibliothèque commune",
      "uppercase": true,
      "icon": "plus-circle",
      "right": true,
      "type-shadow": "shadow-indigo",
      "enable-action": false
    }
  })], 1), _vm._v(" "), !_vm.$freeParticulier() ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.typeStructure == _vm.constants.TYPE_OF ? 'ReferentielFormation' : 'JobDescription',
        params: {
          action: 'newDesc'
        }
      }
    }
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": 'Créer ' + (_vm.typeStructure == _vm.constants.TYPE_OF ? 'un nouveau référentiel de formation' : 'une nouvelle fiche de poste'),
      "icon": "file-text",
      "right": true,
      "uppercase": true,
      "type-shadow": "shadow-indigo",
      "enable-action": false
    }
  })], 1) : _vm._e()], 1) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }